import BigNumber from 'bignumber.js';

import type { Block } from 'types/api/block';

import { WEI } from 'toolkit/utils/consts';

const ERA_LENGTH = 8_409_600;
const PRODUCER_BPS = 7_000;
const BPS = 10_000;

const ERA_REWARDS_WEI = [
  BigNumber('1200000000000000000'),
  BigNumber('600000000000000000'),
  BigNumber('300000000000000000'),
  BigNumber('150000000000000000'),
];

export default function getBlockTotalReward(block: Block) {
  const era = Math.floor(block.height / ERA_LENGTH);
  const totalConsensusReward = ERA_REWARDS_WEI[Math.min(era, ERA_REWARDS_WEI.length - 1)];

  const producerReward = totalConsensusReward
    .multipliedBy(PRODUCER_BPS)
    .dividedToIntegerBy(BPS);

  const priorityFee = BigNumber(block.priority_fee || '0');

  return producerReward.plus(priorityFee).div(WEI);
}
